import {
  get,
  postJSON,
  post
} from "./request";

// export const standardClassList = (data) => get('/m/classes/standard/list')
// export const standardClassList = (data) => postJSON('/m/classes/standard/batch-import-classes', data)
// 获取巡检任务列表页
export const taskList = (data) => post('task/tasks', data)
// 新增巡检任务
export const addTask = (data) => post('task/store', data)
// 编辑巡检任务
export const editTask = (data) => post('task/update', data)
// 删除巡检任务
export const delTask = (data) => post('task/del', data)





// WEBPACK FOOTER //
// ./src/assets/api/InspectionTaskMG.js